<div class="main-page">
  <div class="container">
    <ngx-spinner></ngx-spinner>
    <div class="plans-area">
      <div class="innerPage plans-area-inner">
        <div class="responsive">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <form
                        [formGroup]="form"
                        (ngSubmit)="onSubmit()"
                        autocomplete="off"
                      >
                        <div class="event-heading">
                          {{
                            status === "update"
                              ? "Update Event"
                              : "Create Event"
                          }}
                        </div>
                        <div style="min-height: 500px">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <textarea
                                  maxlength="50"
                                  class="form-control"
                                  formControlName="eventName"
                                  placeholder="Event Name"
                                  rows="2"
                                  [ngClass]="{
                                    'is-invalid':
                                      submitted && f.eventName.errors
                                  }"
                                >
                                </textarea>
                                <div style="text-align: right" class="margin-b">
                                  <p
                                    style="margin-bottom: -1rem"
                                    class="small error"
                                  >
                                    {{ f.eventName.value?.length || 0 }}/50
                                  </p>
                                </div>

                                <div
                                  *ngIf="submitted && f.eventName.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.eventName.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <input
                                  type="text"
                                  placeholder="Datepicker"
                                  class="form-control"
                                  bsDatepicker
                                  placeholder="Start event"
                                  formControlName="validFrom"
                                  [(ngModel)]="model"
                                  [ngClass]="{
                                    'is-invalid':
                                      submitted && f.validFrom.errors
                                  }"
                                />

                                <div
                                  *ngIf="submitted && f.validFrom.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.validFrom.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-group">
                                <input
                                  type="text"
                                  placeholder="End event"
                                  class="form-control"
                                  bsDatepicker
                                  [(ngModel)]="modelSecond"
                                  formControlName="validTill"
                                  [ngClass]="{
                                    'is-invalid':
                                      submitted && f.validTill.errors
                                  }"
                                />
                                <div
                                  *ngIf="submitted && f.validTill.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.validTill.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                  <div *ngIf="f.validTill?.errors?.error">
                                    End event date cannot earlier than Event
                                    start date.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <!-- <ngb-timepicker class="time-btn" [(ngModel)]="startTime"
                                                                    formControlName="startTime"
                                                                    [ngClass]="{ 'is-invalid': submitted && f.startTime.errors }"></ngb-timepicker> -->
                                <timepicker
                                  class="timepicker"
                                  formControlName="startTime"
                                  [ngClass]="{
                                    'is-invalid':
                                      submitted && f.startTime.errors
                                  }"
                                >
                                </timepicker>

                                <div
                                  *ngIf="submitted && f.startTime.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.startTime.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-group">
                                <!-- <ngb-timepicker class="time-btn" [(ngModel)]="endTime"
                                                                    formControlName="endTime"
                                                                    [ngClass]="{ 'is-invalid': submitted && f.endTime.errors }"></ngb-timepicker> -->
                                <timepicker
                                  class="timepicker"
                                  formControlName="endTime"
                                  [ngClass]="{
                                    'is-invalid': submitted && f.endTime.errors
                                  }"
                                >
                                </timepicker>
                                <div
                                  *ngIf="submitted && f.endTime.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.endTime.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">


                                <input
                                type="text"
                                class="form-control"
                                placeholder="Location Name"
                                />

                              <input
                                  type="text"
                                  class="form-control"
                                  ngx-google-places-autocomplete
                                  formControlName="address"
                                  (onAddressChange)="AddressChange($event)"
                                  placeholder="Address 1"
                                  [ngClass]="{
                                    'is-invalid': submitted && f.address.errors
                                  }"
                                  style="margin-top: 15px;"
                                />  

                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Address2"
                                  style="margin-top: 15px;"
                                />

                                <div
                                  *ngIf="submitted && f.address.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.address.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <textarea
                                  maxlength="250"
                                  class="form-control"
                                  formControlName="description"
                                  placeholder="Event details"
                                  rows="5"
                                  [ngClass]="{
                                    'is-invalid':
                                      submitted && f.description.errors
                                  }"
                                ></textarea>
                                <div style="text-align: right" class="margin-b">
                                  <p
                                    style="margin-bottom: -1rem"
                                    class="small error"
                                  >
                                    {{ f.description.value?.length || 0 }}/250
                                  </p>
                                </div>
                                <div
                                  *ngIf="submitted && f.description.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.description.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row margin-b">
                            <div class="col-md-12">
                              <div class="form-group">
                                <button
                                  type="button"
                                  (click)="open(content)"
                                  class="btn btn-style btn-light color main-backgroundcolor"
                                >
                                  {{
                                    status === "update"
                                      ? "Update Event Photo"
                                      : "Add Event Photo"
                                  }}
                                </button>

                                <input
                                  type="hidden"
                                  formControlName="photo"
                                  [ngClass]="{
                                    'is-invalid': submitted && f.photo.errors
                                  }"
                                />

                                <div
                                  *ngIf="submitted && f.photo.errors"
                                  class="invalid-feedback"
                                >
                                  <div
                                    style="text-align: right"
                                    *ngIf="f.photo.errors.required"
                                  >
                                    {{ errorMessage }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="showImage" class="row margin-b">
                            <div class="col-md-12">
                              <div class="form-group" style="display: flex; justify-content: center ;">
                                <div
                                  class="image-wrapper"
                                  style="width: 300px; height: 150px"
                                >
                                  <img
                                    [src]="eventImage"
                                    style="width: 100%; height: 150px"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style="color: white; font-size: large">
                            <h5 style="width: fit-content">
                              Send Event Reminders:
                            </h5>
                          </div>

                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <div class="form-check form-check-inline">
                                  <input
                                    class="form-check-input margin-t"
                                    type="checkbox"
                                    (change)="check($event, 'visitors')"
                                    id="inlineCheckbox1"
                                    value="false"
                                    formControlName="notifyVisitors"
                                  />
                                  <label
                                    class="form-check-label margin-l text-white"
                                    for="inlineCheckbox1"
                                    >Days Before</label
                                  >
                                  <!-- Select number of DAYS before the
                                    event -->
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="showDays" class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <select
                                  class="form-control"
                                  formControlName="notifyVisitorsBefore"
                                  id="sel1"
                                >
                                  <option value="">Select Days</option>
                                  <option
                                    *ngFor="let props of datesArray"
                                    [value]="props"
                                  >
                                    {{ props }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <div class="form-check form-check-inline">
                                  <input
                                    class="form-check-input margin-t"
                                    type="checkbox"
                                    (change)="check($event, 'attendees')"
                                    id="inlineCheckbox1"
                                    value="false"
                                    formControlName="notifyAttenders"
                                  />
                                  <label
                                    class="form-check-label margin-l text-white"
                                    for="inlineCheckbox1"
                                  >Hours Before
                                    </label
                                  >
                                  <!-- Select number of HOURS before the
                                    event -->
                                </div>
                              </div>
                            </div>
                          </div>


                          <div *ngIf="showhours" class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <select
                                  class="form-control"
                                  formControlName="notifyAttenderBefore"
                                  id="sel1"
                                >
                                  <option value="">Select hours</option>
                                  <option
                                    *ngFor="let props of hourArray"
                                    [value]="props"
                                  >
                                    {{ props }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <select
                                class="btn11 form-control"
                                [ngClass]="{
                                  'is-invalid':
                                    submitted && f.accessibility.errors
                                }"
                                formControlName="accessibility"
                              >
                                <option value="">Select Privacy Setting</option>
                                <option value="public">Public</option>
                                <option value="followers">Followers</option>
                                <option value="my followers & congregation">My Followers & Congregation</option>
                              </select>
                              <div
                                *ngIf="submitted && f.accessibility.errors"
                                class="invalid-feedback"
                              >
                                <div
                                  style="text-align: right"
                                  *ngIf="f.accessibility.errors.required"
                                >
                                  {{ errorMessage }}
                                </div>
                                <!-- <div *ngIf="f.accessibility?.errors?.error">Required</div> -->
                              </div>
                            </div>
                          </div>

                          <br />
                          <button
                            type="submit"
                            class="btn color btn-lg btn-block btn-success"
                          >
                            {{ status === "update" ? "Submit" : "Create" }}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header main-backgroundcolor modalHeader color">
    <h4 class="modal-title" id="modal-basic-title ">Select Image</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span class="color" aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body custom-modal-body">
    <div *ngIf="!loading" class="grid-container">
      <div class="grid-item" *ngFor="let props of gallaryArr; let i = index">
        <div class="image-wrapper"></div>
      </div>
    </div>

    <div *ngIf="loading" class="grid-container">
      <div class="grid-item" *ngFor="let props of gallaryArr; let i = index">
        <div class="image-wrapper" [class.selected]="selectedItem == i" (click)="selectImage(props, i)" tabindex="0">
          <img
            class="zoom"
            [src]="checkImage(props.url)"
            (error)="getErrorImage($event)"
            style="margin-top: 20px;"
            alt="Gallery image"
          />
          <div *ngIf="selectedItem == i" class="check-badge" aria-hidden="true">
            <span class="checkmark">✓</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-select"
      [disabled]="selectedItem == null || selectedItem === undefined"
      (click)="addimageForm(); modal.close('Save click')"
    >
      <span class="btn-icon">✔</span>
      Use Selected Image
    </button>
  </div>
</ng-template>
